export const SERVER_URL = "https://do-calculate.com/api";

export const BMI_EndPoint = "calculate-bmi";
export const BMI_Child_EndPoint = "calculate-child-bmi";
export const Calories_EndPoint = "calculate-calories";
export const BMR_EndPoint = "calculate-bmr";
export const IdealWeight_EndPoint = "calculate-ideal-weight";
export const BodyFat_EndPoint = "calculate-body-fat";
export const FoodEnergy_EndPoint = "calculate-food-energy";
export const healthCalculators = [
  {
    name: "حساب مؤشر كتلة الجسم BMI",
    link: "/calculator/ar/bmiadults/",
    description: "هذه الحاسبة تقوم بحساب مؤشر كتلة الجسم (BMI) للبالغين. وحساب الوزن المثالي بحسب الطول والوزن.",
    showMain: true,
  },
  {
    name: "حساب مؤشر كتلة الجسم للأطفال BMI",
    link: "/calculator/ar/bmichildren/",
    description: "تستخدم هذه الحاسبة لحساب مؤشر كتلة الجسم (BMI) للأطفال.",
    showMain: true,
  },
  {
    name: "حاسبة السعرات الحرارية (BMR)",
    link: "/calculator/ar/calories/",
    description:
      "تقوم هذه الحاسبة بحساب عدد السعرات الحرارية اليومي اللازمة للحفاظ على الوزن أو زيادته أو نقصانه.",
    showMain: true,
  },
  {
    name: "حساب معدل الايض الاساسي BMR",
    link: "/calculator/ar/bmr/",
    description:
      "هذه الحاسبة تحسب معدل الأيض الأساسي (BMR) الذي يعبر عن السعرات الحرارية التي يحتاجها جسمك في حالة الراحة.",
  },
  {
    name: "حساب الوزن المثالي للطول",
    link: "/calculator/ar/idealweight/",
    description: "تساعد هذه الحاسبة في حساب الوزن المثالي الذي يتناسب مع طولك.",
    showMain: true,
  },
  {
    name: "حساب نسبة الدهون في الجسم",
    link: "/calculator/ar/bodyfat/",
    description:
      "تستخدم هذه الحاسبة لحساب نسبة الدهون في جسمك بناءً على بعض القياسات.",
    showMain: true,
  },
  {
    name: "حساب الكربوهيدرات في الجسم",
    link: "/calculator/ar/carbohydrate/",
    description:
      "تقوم هذه الحاسبة بحساب الكمية المناسبة من الكاربوهيدرات التي يجب تناولها يومياً. احسب الكارب.",
  },
  {
    name: "حساب التحويل بين وحدات الطاقة الغذائية",
    link: "/calculator/ar/foodenergy/",
    description:
      "هذه الحاسبة تساعد في تحويل بين وحدات الطاقة الغذائية المختلفة مثل السعرات والجول والكيلوجول.",
  },
  {
    name: "حاسبة البروتين",
    link: "/calculator/ar/protein/",
    description:
      "استخدم حاسبة البروتين لتقدير الكمية المحددة لتناول البروتين يوميًا (جرام / يوم) لفقدان الوزن واكتساب قوة العضلات.",
    showMain: true,
  },
  {
    name: "حاسبة النوم الصحي",
    link: "/calculator/ar/sleep/",
    description:
      "استخدم هذه الآلة الحاسبة لحساب الوقت المناسب للذهاب إلى السرير أو الاستيقاظ لتستيقظ منتعشًا بين دورات النوم",
    showMain: true,
  },
  {
    name: "حاسبة طبيعة الجسم",
    link: "/calculator/ar/body-type-calculator/",
    description:
      "تساعدك حاسبة نوع الجسم على تحديد نوع جسمك بناءً على مقاسات الصدر والخصر والفخذين والورك. يمكن أن توفر لك رؤى حول شكل جسمك.",
  },
  {
    name: "حاسبة كمية المياه اليومية",
    link: "/calculator/ar/daily-water-intake-calculator/",
    description:
      "تساعدك حاسبة كمية المياه اليومية على تحديد الكمية المناسبة من المياه التي يجب أن تشربها يوميًا بناءً على وزنك، مستوى نشاطك، والمناخ الذي تعيش فيه.",
  },
  {
    name: "حاسبة الجرعة اليومية للفيتامينات",
    link: "/calculator/ar/vitamin_daily_dose/",
    description:
      "استخدم هذه الأداة لحساب الجرعة اليومية المثلى من الفيتامينات الضرورية لصحة الجسم بناءً على احتياجاتك الفردية. توفر لك هذه الحاسبة طريقة سريعة لمعرفة الجرعة المناسبة من الفيتامينات.",
  },
  {
    name: "حاسبة القيم الغذائية للطعام",
    link: "/calculator/ar/food-nutrients-calculator/",
    description:
      "استخدم هذه الأداة لحساب الجرعة اليومية المثلى من الفيتامينات الضرورية لصحة الجسم بناءً على احتياجاتك الفردية. توفر لك هذه الحاسبة طريقة سريعة لمعرفة الجرعة المناسبة من الفيتامينات.",
  },
  {
    name: "حاسبة مؤشر سمنة الجسم BAI",
    link: "/calculator/ar/bai-calculator/",
    description:
      " استخدم هذه الحاسبة لتحديد مؤشر كتلة الدهون في جسمك (BAI) بشكل دقيق ",
  },
  {
    name: "حاسبة شكل الوجه",
    link: "/calculator/ar/face-shape-calculator/",
    description:
      "تقوم هذه الحاسبة بتحديد شكل الوجه بناءً على قياسات الوجه والملامح.",
  },
  {
    name: "حاسبة نسبة سكر الدم",
    link: "/calculator/ar/blood-sugar-calculator/",
    description: "استخدم هذه الحاسبة لحساب نسبة السكر في الدم",
  },
  {
    name: "حاسبة خطر الإصابة بمرض السكري",
    link: "/calculator/ar/diabetes-risk-calculator/",
    description:
      "احسب نسبة خطر الإصابة بمرض السكري خلال 7.5 سنوات بناءً على بياناتك الصحية.",
  },
  {
    name: "حاسبة متوسط الجلوكوز المقدر",
    link: "/calculator/ar/estimated-average-glucose-calculator/",
    description:
      "استخدم هذه الحاسبة لحساب متوسط الجلوكوز التقديري بناءً على نسبة HbA1c.",
  },
  {
    name: "حساب جرعة الدواء - حاسبة الجرعة الدوائية",
    link: "/calculator/ar/medicine-dosage-calculator/",
    description:
      "استخدم هذه الحاسبة لحساب الجرعة اليومية المناسبة بناءً على وزن المريض.",
  },
  {
    name: "حاسبة جرعة الباراسيتامول للأطفال",
    link: "/calculator/ar/children-paracetamol-dosage-calculator/",
    description:
      "استخدم هذه الحاسبة لحساب الجرعة اليومية المناسبة من الباراسيتامول بناءً على وزن الطفل وتركيز الدواء.",
  },
  {
    name: "حاسبة وظائف الكلى - حساب معدل الترشيح الكبيبي GFR",
    link: "/calculator/ar/gfr-calculator/",
    description:
      "استخدم حاسبة معدل الترشيح الكبيبي (GFR) لتقدير كفاءة عمل الكلى بناءً على مستويات الكرياتينين في الدم. تقدم هذه الحاسبة تقديراً دقيقاً لوظائف الكلى وتساعد في التشخيص المبكر لأمراض الكلى. معرفة GFR الخاص بك يمكن أن يكون خطوة حاسمة للحفاظ على صحة الكلى.",
  },
  {
    name: "اختبار النظر - حاسبة فحص وقياس النظر",
    link: "/calculator/ar/eye-test/",
    description:
      "تقوم الحاسبة بإجراء فحص للأعين بشكل بسيط وواضح بالاعتماد على اختبار سنيلين",
  },
  {
    name: "حاسبة معدل نبضات القلب المستهدفة أثناء التمرين",
    link: "/calculator/ar/heartbeat-calculator/",
    description: "احسب معدل نبضات القلب المثالي بناءً على عمرك وشدة التمرين.",
  },
  {
    name: "حاسبة الإدمان",
    link: "/calculator/ar/addiction-calculator/",
    description: "احسب مقدار العمر المفقود نتيجة الإدمان.",
  },
  {
    name: "حاسبة التعافي من التدخين",
    link: "/calculator/ar/smoking-recovery-calculator/",
    description: "اكتشف فوائد الإقلاع عن التدخين ومدى التحسن في صحتك",
  },
  {
    name: "حاسبة نسبة الكوليسترول",
    link: "/calculator/ar/cholesterol-ratio-calculator/",
    description: "هذه الحاسبة تساعدك في معرفة نسبة الكوليسترول وصحة القلب",
  },
  {
    name: "حاسبة السعرات الحرارية من الخطوات",
    link: "/calculator/ar/steps-to-calories/",
    description: "احسب السعرات الحرارية المحروقة بناءً على عدد الخطوات التي مشيتها.",
  },
  {
    name: "حاسبة السعرات الحرارية من المشي",
    link: "/calculator/ar/walking-calories/",
    description: "تقوم حاسبة السعرات الحرارية للمشي بحساب عدد السعرات الحرارية التي تحرقها أثناء المشي أو الجري على جهاز المشي..",
  },
  // coffee-caffeine
  {
    name: "حاسبة معدل شرب القهوة اليومي",
    link: "/calculator/ar/coffee-caffeine/",
    description: "حاسبة معدل شرب القهوة اليومي لمعرفة كمية الكافيين المناسبة لك بناءً على وزنك ونوع القهوة",

  }
];
export default healthCalculators;